const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomization(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 32,
    viewBox: "0 0 32 32",
    width: 32,
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#7884c3",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    d: "M6 6h20v20H6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 6h20M6 26h20M10 3v3m8-3v3m-4-3v3m8-3v3M10 29v-3m8 3v-3m-4 3v-3m8 3v-3",
    style: {
      opacity: 1,
      fill: "none",
      stroke: "#1f1f1f",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      paintOrder: "fill markers stroke",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 10h20",
    style: {
      opacity: 1,
      fill: "none",
      stroke: "#dbbd5f",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      paintOrder: "fill markers stroke",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 22v-6c0-2 5-3 5-3v0s5 1 5 3v6",
    style: {
      opacity: 1,
      fill: "#67a96d",
      stroke: "#dbbd5f",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeOpacity: 1,
      paintOrder: "fill markers stroke",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 22h20",
    style: {
      opacity: 1,
      fill: "none",
      stroke: "#dbbd5f",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      paintOrder: "fill markers stroke",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 3v26M26 3v26",
    style: {
      opacity: 1,
      fill: "none",
      stroke: "#1f1f1f",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      paintOrder: "fill markers stroke",
      strokeOpacity: 1
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomization);
export default __webpack_public_path__ + "static/media/customization.c52b4707fc6ccd5fd6effea6fd06c6af.svg";
export { ForwardRef as ReactComponent };